const locale = {
    placeholder: 'Selezionare il tempo',
};
export default locale;
